import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {INDRASeatmapService} from '@ibe.services/seatmap.indra.service';
import {Observable} from 'rxjs';
import {Action} from '@ngrx/store';
import * as SeatmapActions from '../actions/seatmap.actions';
import {map, switchMap} from 'rxjs/operators';
import {Seatmap} from '@ibe.models/seatmap.model.lib';

@Injectable()
export class SeatmapEffects {
	constructor(
		private actions$: Actions,
		private seatmapService: INDRASeatmapService
	) { }

	@Effect()
	loading$: Observable<Action> = this.actions$.pipe(
		ofType(SeatmapActions.ActionTypes.LOADING),
		map((action: SeatmapActions.LoadAircraftJSONAction) => action.payload),
		switchMap(({aircraftFile}) => this.seatmapService.INDRA_getCabinTemplateURL(aircraftFile)),
		map((data: Seatmap) => new SeatmapActions.PutSeatmapAction(data))
	);
}
